import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowLeft } from 'lucide-react';
import { cn } from '../../utils/cn';

/**
 * Top bar on legal/content pages: home + contact (hidden on / and /contact).
 */
export function PageSubnav() {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  if (pathname === '/' || pathname === '/contact') {
    return null;
  }

  return (
    <div
      className={cn(
        'sticky top-0 z-50 border-b border-black/[0.06]',
        'bg-white/90 py-3 backdrop-blur-md supports-[backdrop-filter]:bg-white/80',
      )}
    >
      <div className="mx-auto flex max-w-6xl flex-wrap items-center gap-2 px-safe sm:gap-3 md:px-8">
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 rounded-full border border-black/[0.1] bg-white px-4 py-2 text-[13px] font-medium text-[#1d1d1f] shadow-sm transition-colors hover:border-black/20 hover:bg-[#fafafa] focus:outline-none"
        >
          <ArrowLeft className="h-3.5 w-3.5 shrink-0 opacity-80" strokeWidth={2} aria-hidden />
          {t('layout.backToHome')}
        </Link>
        <Link
          to="/contact"
          className="inline-flex items-center justify-center rounded-full bg-accent-dark px-4 py-2 text-[13px] font-semibold text-white shadow-sm transition-colors hover:bg-[#a82f14] focus:outline-none"
        >
          {t('nav.contact')}
        </Link>
      </div>
    </div>
  );
}
